/* istanbul ignore file */
import { getMpAgent } from '../../api/utils/mpAgent'

const MP_ADDRESS_VALIDATION_PATH = '/user/validateAddress'

export interface AddressValidationRequest {
  street: string
  city?: string
  state?: string
  zipCode?: string
  /** ISO country code; defaults to 'US' */
  country?: string
}

export interface AddressValidationResult {
  isPOBox: boolean
}

export class AddressValidationAPI {
  static validate(address: AddressValidationRequest): Promise<AddressValidationResult> {
    return getMpAgent()
      .post(MP_ADDRESS_VALIDATION_PATH, address)
      .then(response => response.data as AddressValidationResult)
  }
}
